 document.addEventListener('DOMContentLoaded', function () {

    function initSlick() {
      if (window.innerWidth < 750) {
        if (!$('.slick-mobile-slider').hasClass('slick-initialized')) {
          $('.slick-mobile-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed:1000,
            dots: false,
            arrows: false,
            infinite: true
          });
        }
      } else {
        if ($('.slick-mobile-slider').hasClass('slick-initialized')) {
          $('.slick-mobile-slider').slick('unslick');
        }
      }
    }

  initSlick();
  window.addEventListener('resize', initSlick);

});
  

jQuery(document).ready(function () {
  jQuery('.collection-slider').slick({
    dots: false,
    arrows:true,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

